import { Icon, InputNumber, Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './index.module.less';

const ModernPagination = ({ pageSize, current, total, onPageSizeChange, onPageNoChange }) => {
  const { formatMessage } = useIntl();
  const onSizeChange = (pSize, pageNo, totalPages) => {
    if (onPageSizeChange && pSize && !Number.isNaN(pSize) && pSize > 0) onPageSizeChange(pSize);
    if (onPageNoChange && pageNo && Number(pageNo) > totalPages) onPageNoChange(totalPages);
    const input = document.getElementById('itemsInput');
    input.onblur = (event) => {
      if (event.target.value === '') {
        onSizeChange(15, current, totalPages);
        // eslint-disable-next-line no-param-reassign
        event.target.value = '15';
      }
    };
  };

  const onChange = (pageNo, totalPages) => {
    if (onPageNoChange && pageNo && Number(pageNo) <= totalPages) onPageNoChange(pageNo);
  };

  const totalPages = Math.ceil(total / pageSize);

  return (
    total > 0 && (
      <div className={styles.paginationParent}>
        <div className={styles.pageSizer}>
          <span data-test="itemsPerPageText">{formatMessage({ id: 'text.itemsPerPage' })}:</span>
          <InputNumber
            className={styles.paginationInput}
            defaultValue={pageSize}
            onChange={(val) => onSizeChange(val, current, totalPages)}
            min={1}
            data-test="itemsPerPageInput"
            id="itemsInput"
          />
        </div>
        <div className={styles.pagePaginator}>
          <Button
            type="link"
            className={`${styles.prevArrow} ${current === 1 ? styles.disabled : undefined}`}
            onClick={() => onChange(current - 1, totalPages)}
            data-test="backArrow"
          >
            <Icon type="left" />
          </Button>
          <InputNumber
            className={styles.paginationInput}
            value={current}
            onChange={(val) => onChange(val, totalPages)}
            max={totalPages}
            data-test="currentInput"
          />
          <span data-test="totalPages">
            {formatMessage({ id: 'text.of' })} {totalPages}
          </span>
          <Button
            type="link"
            className={`${styles.nextArrow} ${current === totalPages ? styles.disabled : undefined}`}
            onClick={() => onChange(current + 1, totalPages)}
            data-test="nextArrow"
          >
            <Icon type="right" />
          </Button>
        </div>
      </div>
    )
  );
};

ModernPagination.propTypes = {
  pageSize: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  onPageNoChange: PropTypes.func.isRequired,
};

export default ModernPagination;
